import { IconClock } from "@tabler/icons-react";
import styles from "./PendingBadge.module.css";

export default function PendingBadge() {
  return (
    <span className={styles.badge}>
      <IconClock size={12} />
      Pending
    </span>
  );
}
